import { ADMIN_SERVICE_LIST } from './index';
import { Action } from '../action';
import { AccessCodeServiceInfo } from '@shared/core';

export class AdminServiceListInitAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceListDestroyAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceListHydrateAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceListHydrateSuccessAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.HYDRATE_SUCCESS;
	constructor(
		public payload: AccessCodeServiceInfo[],
		public correlationId?: number
	) {}
}

export class AdminServiceListHydrateFailureAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminServiceListDeleteAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.DELETE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceListDeleteSuccessAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.DELETE_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceListDeleteFailureAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.DELETE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminServiceListClickAddAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.CLICK_ADD;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceListClickEditAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.CLICK_EDIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceListClickDeleteAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.CLICK_DELETE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceListSelectAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.SELECT;
	constructor(
		public payload: AccessCodeServiceInfo,
		public correlationId?: number
	) {}
}

export class AdminServiceListSelectOrganizationGroupAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.SELECT_ORGANIZATION_GROUP;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminServiceListSelectOrganizationAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.SELECT_ORGANIZATION;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminServiceListClickOrganizationBacklinkAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.CLICK_ORGANIZATION_BACKLINK;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminServiceListClickGroupBacklinkAction implements Action {
	readonly type = ADMIN_SERVICE_LIST.CLICK_GROUP_BACKLINK;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
